<div class="site-map needsclick here-map" :class="[{drawing: drawing},mapTheme,{mobile:isMobileSize}, {'show-search-bar': showSearchBar}]">
    <div class="map-box" ref="mapbox"></div>

    <slot name="tools" :applyMap="applyMap" :clearBoundary="clearBoundary" :updateSchoolMarker="updateSchoolMarker">
        <template v-for="item in calTools">
            <tool-map-type :key="item.name" v-if="item.name==='maptype'" class="map-tool" :css="item.css"
                :icon="item.icon" />
            <tool-zoom :key="item.name" v-else-if="item.name==='zoom'" class="map-tool" :css="item.css" />
            <nearby :key="item.name" v-else-if="item.name==='nearby'" class="map-tool" :css="item.css" />
            <fullscreen :key="item.name" v-else-if="item.name==='fullscreen'" :icon="item.icon||''" class="map-tool"
                :css="item.css" />
            <locate :key="item.name" v-else-if="item.name==='locate'" class="map-tool" :css="item.css" />
            <street :key="item.name" v-else-if="item.name==='street'" class="map-tool" :css="item.css" />
            <draw :key="item.name" v-else-if="item.name==='draw'" class="map-tool"
                :css="handlerCss(item.css,item.changeStyle)" :drawIcon="item.drawIcon" :clearIcon="item.clearIcon"
                @change="onMapPathChange" />
            <search :key="item.name" v-else-if="item.name==='search'" class="map-tool"
                :css="handlerCss(item.css,item.changeStyle)" :text="item.text" />
            <school :key="item.name" v-else-if="item.name==='school'" class="map-tool"
                :css="handlerCss(item.css,item.changeStyle)" :icon="item.icon" :value="item.value"
                @update="updateSchoolMarker" />
            <icon :key="item.name" v-else-if="item.name==='map-mask'" :icon="item.icon" :css="item.css"
                :handler="item.handler" />
            <icon :key="item.name" v-else class="map-tool" :icon="item.icon" :css="item.css" :handler="item.handler" />
        </template>
    </slot>
    <div class="marker-box aggre">
        <marker-aggre v-for="(item,index) in aggregationMarkers" :key="item.key" class="map-marker" :data="item"
            :events="markerEventMap.aggre || {}" v-model:active="markerActiveMap.aggre"/>
    </div>
    <div class="marker-box icon">
        <marker-icon v-for="(item,index) in iconMarkers" :key="item.key" class="map-marker" :data="item" :useIconAddress="useIconAddress"
            :events="markerEventMap[item.type] || {}" v-model:active="markerActiveMap[item.type]" />
    </div>
    <div class="marker-box house">
        <template v-if="mapTheme === 'broker'">
            <MarkerHouseBroker v-for="(item, index) in houseMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"/>
        </template>
        <template v-else-if="mapTheme === 'layout1'">
            <MarkerHouseLayout v-for="(item, index) in houseMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"/>
        </template>
        <template v-else>
            <MarkerHouse v-for="(item, index) in houseMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"/>
        </template>
    </div>
    <div class="marker-box listing">
        <template v-if="mapTheme === 'broker'">
            <MarkerHouseBroker v-for="(item, index) in listingMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"
                @markerReady="onMarkerReady('listing', index)" v-show="!item.hidden" />
        </template>
        <template v-else-if="mapTheme === 'layout1'">
            <MarkerHouseLayout v-for="(item, index) in listingMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"
                @markerReady="onMarkerReady('listing', index)" v-show="!item.hidden" />
        </template>
        <template v-else>
            <MarkerHouse v-for="(item, index) in listingMarkers" :key="item.key" :data="item"
                :events="markerEventMap.house || {}" v-model:active="markerActiveMap.house"
                @markerReady="onMarkerReady('listing', index)" v-show="!item.hidden" />
        </template>
    </div>
    <div class="marker-box school">
        <MarkerSchoolLayout v-if="mapTheme === 'layout1'" v-for="(item, index) in schoolMarkers" :key="item.key" class="map-marker" :data="item"
            :events="markerEventMap.schoolDetail || {}" v-model:active="markerActiveMap.schoolDetail"
            :icon="mapTheme==='classic'?'icon-school3':'icon-school2'" />
        <MarkerSchool v-else v-for="(item, index) in schoolMarkers" :key="item.key" class="map-marker" :data="item"
            :events="markerEventMap.schoolDetail || {}" v-model:active="markerActiveMap.schoolDetail"
            :icon="mapTheme==='classic'?'icon-school3':'icon-school2'" />
    </div>
    <div class="marker-box city">
        <MarkerCity v-for="(item, index) in cityMarkers" :key="item.key" class="map-marker" :data="item"
            :events="markerEventMap.city || {}" v-model:active="markerActiveMap.city" />
    </div>
    <slot></slot>
    <map-mask v-if="config.gestureHandling=='greedy'" />
</div>